import { useThemeValues } from "../../src/hooks/useThemeValues";
import type { Color } from "../../src/types/color.emotion.types";
/**
 * A utility type to represent a style object that can be used with Emotion
 */
export type StyleObject = Record<string, any>;

/**
 * A utility type to represent a style function that takes props and returns a style object
 */
export type StyleFunction<P = any> = (props: P) => StyleObject;

/**
 * A utility type to represent a style that can be either an object or a function
 */
export type Style<P = any> = StyleObject | StyleFunction<P>;

/**
 * Creates a style object from multiple style objects or functions
 * This mimics the behavior of stylex.create()
 *
 * @param styles An object of style objects or functions
 * @returns An object with the same keys, typed as any so values are assignable to css props
 */
export function createStyles<T extends Record<string, Style>>(
  styles: T,
): {
  [K in keyof T]: any;
} {
  return styles;
}

export function useEmotionColor() {
  const theme = useThemeValues();
  return (colorVar: Color) =>
    theme.semanticColors[colorVar] ??
    theme.constantSemanticColors[colorVar] ??
    theme.colors[colorVar] ??
    colorVar;
}
